import PhoenixScottsdale, { getServerSideProps } from './Scottsdale';
export default PhoenixScottsdale;
export { getServerSideProps };
